import { create } from 'asciinema-player';
import ollama_cast from './ollama-rev00.cast';
import pd_cast from './podmanDaemon-rev00.cast';
import pi_cast from './podmanInteractive-rev00.cast';
import pmio_cast from './podmanMinIO-rev00.cast';

create(pi_cast,
       document.getElementById('demo-podman'),
       {loop: true }
      );

create( pd_cast,
       document.getElementById('demo-podmanDaemon'),
       {loop: true }
      );

create(ollama_cast,
       document.getElementById('demo-ollama'),
       {loop: true }
      );

create(pmio_cast,
       document.getElementById('demo-podmanMinIO'),
       {loop: true }
      );

